export default __webpack_public_path__ + "static/16079-70e7cd444608ba7b912d301a5ad38d65.jpg";